import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=44a4de94"
import script from "./Cards.vue?vue&type=script&lang=ts"
export * from "./Cards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports